module.exports = __webpack_public_path__ + "static/media/teygja_bakvodvar_rodur_small.b47bac0e.png";